import { create } from 'zustand';

import { SUBSCRIBER_PAGE_SIZE, type SubscriberSource } from './subscribers';

interface SubscribersQueryState {
  search: string;
  source: 'all' | SubscriberSource;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setSource: (source: 'all' | SubscriberSource) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<SubscribersQueryState, 'search' | 'source' | 'page' | 'pageSize'> = {
  search: '',
  source: 'all',
  page: 1,
  pageSize: SUBSCRIBER_PAGE_SIZE,
};

export const useSubscribersStore = create<SubscribersQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setSource: (source) => set({ source, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
